import AppContent from '@Components/app-layout/Content';

import Routes from './Routes';

export default function ProfileLayout() {
  return <AppContent>
    <Routes />
  </AppContent>
}
